(function () {
  'use strict';

  function formatMoney(cents) {
    var c = Number(cents);
    if (!Number.isFinite(c)) return '';

    var formatted;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var fmt =
        (window.Theme && window.Theme.moneyFormat) || '${{amount}}';
      formatted = window.Shopify.formatMoney(c, fmt);
    } else {
      formatted = '$' + (c / 100).toFixed(2);
    }

    return formatted.replace(/\.00(?=\D*$)/, '');
  }

  function getProductJson(sectionId) {
    var el = document.querySelector('[data-product-json-' + sectionId + ']');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getProductForm(sectionId) {
    return (
      document.querySelector('#product-form-' + sectionId + ' form') ||
      document.querySelector('[data-product-form="' + sectionId + '"]') ||
      document.querySelector('section.product form[action*="/cart/add"]')
    );
  }

  function getSelectedVariantId(form, productSection) {
    var swatch = productSection.querySelector(
      'input[name="nw-product-swatch"]:checked'
    );
    if (swatch && swatch.value) return String(swatch.value);

    if (!form) return null;
    var input = form.querySelector('[name="id"]');
    return input ? String(input.value) : null;
  }

  function findVariant(product, variantId) {
    if (!product || !variantId) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(variantId)) {
        return product.variants[i];
      }
    }
    return null;
  }

  function buildTitle(product, variant, showVariant, productSection) {
    if (!product) return '';

    var swatch = productSection.querySelector(
      'input[name="nw-product-swatch"]:checked'
    );
    if (swatch) {
      var swatchLabel = productSection.querySelector(
        'label[for="' + swatch.id + '"]'
      );
      if (swatchLabel && swatchLabel.textContent.trim()) {
        return product.title + ' | ' + swatchLabel.textContent.trim();
      }
    }

    var title = product.title || '';
    if (
      showVariant &&
      variant &&
      variant.title &&
      variant.title !== 'Default Title'
    ) {
      title = title + ' | ' + variant.title;
    }
    return title;
  }

  function getDisplayPrice(productSection, product, variantId) {
    var swatch = productSection.querySelector(
      'input[name="nw-product-swatch"]:checked'
    );
    if (swatch) {
      var swatchPrice = swatch.getAttribute('data-price');
      if (swatchPrice && swatchPrice.trim()) {
        return swatchPrice.trim();
      }
      var swatchAmount = swatch.getAttribute('data-price-amount');
      if (swatchAmount) {
        return formatMoney(parseInt(swatchAmount, 10));
      }
    }

    var mainPrice = productSection.querySelector(
      '.product-price .money:not(.original)'
    );
    if (mainPrice && mainPrice.textContent.trim()) {
      return mainPrice.textContent.trim();
    }

    var variant = findVariant(product, variantId);
    if (variant) return formatMoney(variant.price);

    return '';
  }

  function getDisplayComparePrice(productSection, product, variantId) {
    var mainCompare = productSection.querySelector(
      '.product-price .original.money'
    );
    if (
      mainCompare &&
      !mainCompare.classList.contains('hidden') &&
      mainCompare.textContent.trim()
    ) {
      return mainCompare.textContent.trim();
    }

    var swatch = productSection.querySelector(
      'input[name="nw-product-swatch"]:checked'
    );
    if (swatch) {
      var comparePrice = swatch.getAttribute('data-compare-price');
      var saveAmount = swatch.getAttribute('data-save-amount');
      if (
        comparePrice &&
        comparePrice.trim() &&
        saveAmount &&
        saveAmount.trim()
      ) {
        return comparePrice.trim();
      }
    }

    var variant = findVariant(product, variantId);
    if (
      variant &&
      variant.compare_at_price &&
      variant.compare_at_price > variant.price
    ) {
      return formatMoney(variant.compare_at_price);
    }

    return '';
  }

  function getAffirmAmount(productSection, product, variantId) {
    var swatch = productSection.querySelector(
      'input[name="nw-product-swatch"]:checked'
    );
    if (swatch) {
      var swatchAmount = swatch.getAttribute('data-price-amount');
      if (swatchAmount) return parseInt(swatchAmount, 10);
    }

    var variant = findVariant(product, variantId);
    if (variant) return variant.price;
    return product ? product.price_min : 0;
  }

  function initStickyCta(sticky) {
    if (!sticky || sticky.dataset.nwStickyInit === 'true') return;

    var sectionId = sticky.getAttribute('data-section-id');
    var sectionRoot =
      sticky.closest('.shopify-section') ||
      sticky.closest('[id^="shopify-section"]') ||
      document;
    var productSection = sectionRoot.querySelector('section.product');
    var form = getProductForm(sectionId);
    var product = getProductJson(sectionId);
    var showVariant = sticky.getAttribute('data-show-variant') === 'true';
    var showAffirm = sticky.getAttribute('data-show-affirm') === 'true';

    var titleEl = sticky.querySelector('[data-nw-sticky-cta-title]');
    var comparePriceEl = sticky.querySelector('[data-nw-sticky-cta-compare-price]');
    var priceEl = sticky.querySelector('[data-nw-sticky-cta-price]');
    var affirmEl = sticky.querySelector('[data-nw-sticky-cta-affirm]');
    var btn = sticky.querySelector('[data-nw-sticky-cta-button]');

    if (!productSection || !form || !btn) return;

    sticky.dataset.nwStickyInit = 'true';

    function syncContent() {
      var variantId = getSelectedVariantId(form, productSection);
      var variant = findVariant(product, variantId);

      if (titleEl) {
        titleEl.textContent = buildTitle(
          product,
          variant,
          showVariant,
          productSection
        );
      }

      if (priceEl) {
        priceEl.textContent = getDisplayPrice(
          productSection,
          product,
          variantId
        );
      }

      if (comparePriceEl) {
        var compareText = getDisplayComparePrice(
          productSection,
          product,
          variantId
        );
        if (compareText) {
          comparePriceEl.textContent = compareText;
          comparePriceEl.hidden = false;
          comparePriceEl.classList.remove('hidden');
        } else {
          comparePriceEl.textContent = '';
          comparePriceEl.hidden = true;
          comparePriceEl.classList.add('hidden');
        }
      }

      if (affirmEl && showAffirm) {
        var affirmInner = affirmEl.querySelector('.affirm-as-low-as');
        var amount = getAffirmAmount(productSection, product, variantId);
        if (affirmInner) {
          affirmInner.setAttribute('data-amount', String(amount));
        }
        if (window.affirm && typeof window.affirm.ui.refresh === 'function') {
          window.affirm.ui.refresh();
        }
      }

      var swatchAvailable = swatchAvailableCheck(productSection);
      var available = true;
      if (swatchAvailable !== null) {
        available = swatchAvailable;
      } else if (variant) {
        available = variant.available;
      } else if (product) {
        available = product.available;
      }

      btn.disabled = !available;
      btn.textContent = !available
        ? btn.getAttribute('data-sold-out-text') || 'Sold Out'
        : btn.getAttribute('data-default-text') || 'Add to Cart';
    }

    function swatchAvailableCheck(productSection) {
      var swatch = productSection.querySelector(
        'input[name="nw-product-swatch"]:checked'
      );
      if (!swatch) return null;
      return !swatch.disabled;
    }

    function bindVariantSync() {
      var variantInput = form.querySelector('select[name="id"], input[name="id"]');
      if (variantInput) {
        variantInput.addEventListener('change', function () {
          window.setTimeout(syncContent, 0);
        });
      }

      productSection.addEventListener('change', function (e) {
        if (!e.target) return;
        if (
          e.target.name === 'nw-product-swatch' ||
          e.target.getAttribute('data-option-input')
        ) {
          window.setTimeout(syncContent, 0);
        }
      });

      var mainPrice = productSection.querySelector(
        '.product-price .money:not(.original)'
      );
      if (mainPrice && typeof MutationObserver !== 'undefined') {
        var priceObserver = new MutationObserver(function () {
          syncContent();
        });
        priceObserver.observe(mainPrice, {
          characterData: true,
          childList: true,
          subtree: true,
        });
      }
    }

    function setVisible(isVisible) {
      sticky.classList.toggle('is-visible', isVisible);
      sticky.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      document.body.classList.toggle('nw-sticky-cta-active', isVisible);
      if (isVisible) {
        document.documentElement.style.setProperty(
          '--nw-sticky-cta-height',
          sticky.offsetHeight + 'px'
        );
      }
    }

    function updateVisibility() {
      var rect = productSection.getBoundingClientRect();
      var show = rect.bottom <= 0;
      setVisible(show);
    }

    var observer = new IntersectionObserver(
      function () {
        updateVisibility();
      },
      { threshold: [0, 0.01, 0.1, 0.25, 0.5, 0.75, 1] }
    );
    observer.observe(productSection);

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });
    updateVisibility();

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.disabled) return;

      var mainSubmit = form.querySelector('.add-to-cart__button');
      if (mainSubmit && !mainSubmit.disabled) {
        mainSubmit.click();
        return;
      }

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });

    bindVariantSync();
    syncContent();

    window.addEventListener('load', syncContent);
  }

  function boot(scope) {
    var root = scope && scope.nodeType === 1 ? scope : document;
    root.querySelectorAll('[data-nw-sticky-cta]').forEach(function (sticky) {
      initStickyCta(sticky);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
